"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./credentialDetailBlock.scss");
const VerifySingleDetail_1 = __importDefault(require("../verifySingleDetail/VerifySingleDetail"));
const verifySingleDetailTypes_1 = require("../verifySingleDetail/verifySingleDetailTypes");
const credentialDetailBlockTranslations_json_1 = __importDefault(require("./credentialDetailBlockTranslations/credentialDetailBlockTranslations.json"));
const master_1 = require("../../../constants/master");
const subdomains_1 = require("../../../constants/subdomains");
const DetailEnums_json_1 = require("../../../translations/DetailEnums.json");
const constants_1 = require("../../../constants/constants");
function CredentialDetailBlock(props) {
    var _a;
    props.addTranslation(credentialDetailBlockTranslations_json_1.default);
    const detailTypes = DetailEnums_json_1.DetailType;
    function getCredTypeTranslationKey() {
        const config = (0, master_1.getMasterConfig)();
        return config.subDomain === subdomains_1.himssSubdomain
            ? "certificateType"
            : "credentialType";
    }
    return (react_1.default.createElement("div", { className: "details", style: {
            gap: "20px",
            marginTop: "25px",
        } },
        react_1.default.createElement(VerifySingleDetail_1.default, { type: verifySingleDetailTypes_1.VerifySingleDetailTypes.ISSUE_DATE, label: props.translate("issueDateDetail").toString(), text: props.createDate }),
        props.type &&
            props.type !==
                detailTypes[((_a = props.activeLanguage) === null || _a === void 0 ? void 0 : _a.code) || "en"][constants_1.DetailType.NA] && (react_1.default.createElement(VerifySingleDetail_1.default, { type: verifySingleDetailTypes_1.VerifySingleDetailTypes.CREDENTIAL_TYPE, label: props.translate(getCredTypeTranslationKey()).toString(), text: props.type })),
        props.duration && (react_1.default.createElement(VerifySingleDetail_1.default, { type: verifySingleDetailTypes_1.VerifySingleDetailTypes.DURATION, label: props.translate("duration").toString(), text: props.duration })),
        props.expireDate && (react_1.default.createElement(VerifySingleDetail_1.default, { type: verifySingleDetailTypes_1.VerifySingleDetailTypes.EXPIRE_DATE, label: props.translate("expireDate").toString(), text: props.expireDate })),
        props.level && (react_1.default.createElement(VerifySingleDetail_1.default, { type: verifySingleDetailTypes_1.VerifySingleDetailTypes.LEVEL, label: props.translate("level2").toString(), text: props.level })),
        props.cost && (react_1.default.createElement(VerifySingleDetail_1.default, { type: verifySingleDetailTypes_1.VerifySingleDetailTypes.COST, label: props.translate("cost").toString(), text: props.cost }))));
}
exports.default = CredentialDetailBlock;
